<template>
  <section class="viewsrhqyBaseManagecomponents_serviceModal">
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="900px"
      @close="onResetForm"
    >
      <div class="service-form-wrap">
        <el-form ref="form" :model="form" label-width="190px" :rules="rules">
          <el-form-item label="预约业务名称" prop="name">
            <el-input
              v-model.trim="form.name"
              placeholder="请输入预约业务名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="业务类型" prop="type">
            <el-radio-group v-model="form.type">
              <el-radio :label="11">送货业务</el-radio>
              <el-radio :label="12">提货业务</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="Number(form.type) === 12"
            label="预约提货类型"
            prop="pickup_booking_type"
          >
            <el-radio-group v-model="form.pickup_booking_type">
              <el-radio label="FINISHED">成品</el-radio>
              <el-radio label="TRI_WASTE">三废</el-radio>
              <el-radio label="OTHER">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="订单类型" prop="order_type">
            <el-radio-group v-model="form.order_type">
              <el-radio label="CD">木片</el-radio>
              <el-radio label="IB">国废</el-radio>
              <el-radio label="NB">化辅</el-radio>
              <el-radio label="OTHER">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="预约成功后直接完成" prop="finish_on_booking">
            <el-radio-group
              v-model="form.finish_on_booking"
              @change="handleFinishOnBookingChange"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <div class="text-xs text-gray-500 mt-2">
              开启后该业务只保留预约记录，预约成功即进入已完成，后续登记、叫号、发退卡、进出厂等流程不再生效。
            </div>
          </el-form-item>
          <el-form-item label="是否出车确认" prop="need_depart_confirm">
            <el-radio-group
              v-model="form.need_depart_confirm"
              :disabled="isFlowConfigDisabled"
              @change="handleDepartConfirmChange"
            >
              <el-radio :label="1">需要</el-radio>
              <el-radio :label="0">不需要</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="Number(form.need_depart_confirm) === 1"
            label="出车确认校验北斗定位"
            prop="outward_beidou_check"
          >
            <el-radio-group
              v-model="form.outward_beidou_check"
              :disabled="isFlowConfigDisabled"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="进出厂模式" prop="access_mode">
            <el-radio-group
              v-model="form.access_mode"
              :disabled="isFlowConfigDisabled"
            >
              <el-radio :label="1">过磅进出厂</el-radio>
              <el-radio :label="2">发卡退卡进出厂</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="Number(form.access_mode) === 1"
            label="推送地磅时机"
            prop="pound_push_timing"
          >
            <el-radio-group
              v-model="form.pound_push_timing"
              :disabled="isFlowConfigDisabled"
            >
              <el-radio label="NONE">不推送</el-radio>
              <el-radio label="BOOKING">预约时推送</el-radio>
              <el-radio label="REPORT">登记时推送</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="推送停车场" prop="parking_lot_push_timing">
            <el-radio-group
              v-model="form.parking_lot_push_timing"
              :disabled="isFlowConfigDisabled"
            >
              <el-radio label="NONE">不推送</el-radio>
              <el-radio label="BOOKING">预约时推送</el-radio>
              <el-radio label="OUTWARD">出车确认时推送</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="停车场校验" prop="parking_lot_space_intercept">
            <el-radio-group
              v-model="form.parking_lot_space_intercept"
              :disabled="isParkingLotSpaceInterceptDisabled"
            >
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
            <div class="text-xs text-gray-500 mt-2">
              开启后，司机需要先被停车场抓拍到场后才能登记；未抓拍时会提示“请先进入停车场完成抓拍后再登记”，只有基地明确回调无空位时才允许直接登记。
            </div>
          </el-form-item>
          <el-form-item label="进厂后节点" prop="post_entry_nodes">
            <el-checkbox-group
              v-model="form.post_entry_nodes"
              :disabled="isFlowConfigDisabled"
            >
              <el-checkbox
                v-for="item in postEntryNodeOptions"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
            <div class="text-xs text-gray-500 mt-2">
              固定顺序：预约 -> 登记 -> 授权位 -> 叫号 -> 进厂 -> 取样 -> 测水 ->
              装卸 -> 出厂。
              未勾选的进厂后节点会自动跳过。
            </div>
          </el-form-item>
          <el-form-item label="指定进厂门岗" prop="info_door_ids">
            <el-select
              multiple
              class="w-full"
              v-model="form.info_door_ids"
              :disabled="isFlowConfigDisabled"
              placeholder="请选择指定进厂门岗"
            >
              <el-option
                v-for="item in doors"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指定出厂门岗" prop="out_door_ids">
            <el-select
              multiple
              class="w-full"
              v-model="form.out_door_ids"
              :disabled="isFlowConfigDisabled"
              placeholder="请选择指定出厂门岗"
            >
              <el-option
                v-for="item in doors"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="note">
            <el-input
              type="textarea"
              :maxlength="50"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="form.note"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="onOk">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import { cloneDeep } from "lodash";

const DEFAULT_POST_ENTRY_NODES = [];
const createConditionalDoorValidator = (vm, message) => (rule, value, callback) => {
  if (Number(vm.form.finish_on_booking) === 1) {
    callback();
    return;
  }

  if (!Array.isArray(value) || value.length === 0) {
    callback(new Error(message));
    return;
  }

  callback();
};

export default {
  data() {
    return {
      visible: false,
      form: {
        id: 0,
        name: "",
        type: 11,
        order_type: "OTHER",
        pickup_booking_type: "OTHER",
        finish_on_booking: 0,
        need_depart_confirm: 0,
        outward_beidou_check: 0,
        access_mode: 1,
        pound_push_timing: "NONE",
        parking_lot_push_timing: "NONE",
        parking_lot_space_intercept: 0,
        post_entry_nodes: [...DEFAULT_POST_ENTRY_NODES],
        category: "",
        pid: "",
        user_list: "",
        auto_auth_units: "",
        note: "",
        enable_loadometer: "",
        car_tag: "",
        info_door_ids: [],
        out_door_ids: []
      },
      rules: {
        name: [
          { required: true, message: "请输入预约业务名称", trigger: "blur" }
        ],
        type: [
          { required: true, message: "请选择业务类型", trigger: "change" }
        ],
        order_type: [
          { required: true, message: "请选择订单类型", trigger: "change" }
        ],
        pickup_booking_type: [
          { required: true, message: "请选择预约提货类型", trigger: "change" }
        ],
        finish_on_booking: [
          {
            required: true,
            message: "请选择是否预约成功后直接完成",
            trigger: "change"
          }
        ],
        need_depart_confirm: [
          {
            required: true,
            message: "请选择是否出车确认",
            trigger: "change"
          }
        ],
        outward_beidou_check: [
          {
            required: true,
            message: "请选择出车确认是否校验北斗定位",
            trigger: "change"
          }
        ],
        access_mode: [
          { required: true, message: "请选择进出厂模式", trigger: "change" }
        ],
        pound_push_timing: [
          {
            validator: (rule, value, callback) => {
              if (Number(this.form.access_mode) !== 1) {
                callback();
                return;
              }
              if (!["NONE", "BOOKING", "REPORT"].includes(value)) {
                callback(new Error("请选择推送地磅时机"));
                return;
              }
              callback();
            },
            trigger: "change"
          }
        ],
        parking_lot_push_timing: [
          {
            required: true,
            message: "请选择推送停车场时机",
            trigger: "change"
          }
        ],
        info_door_ids: [
          {
            validator: createConditionalDoorValidator(
              this,
              "请选择指定进厂门岗"
            ),
            trigger: "change"
          }
        ],
        out_door_ids: [
          {
            validator: createConditionalDoorValidator(
              this,
              "请选择指定出厂门岗"
            ),
            trigger: "change"
          }
        ]
      },
      postEntryNodeOptions: [
        { label: "取样", value: "SAMPLE" },
        { label: "测水", value: "WATER" }
      ],
      doors: []
    };
  },
  computed: {
    title() {
      return this.form.id ? "修改预约业务" : "新增预约业务";
    },
    isFlowConfigDisabled() {
      return Number(this.form.finish_on_booking) === 1;
    },
    isParkingLotSpaceInterceptDisabled() {
      return this.isFlowConfigDisabled || this.form.parking_lot_push_timing === "NONE";
    }
  },
  created() {
    this.getDoors();
  },
  methods: {
    /**
     * 切换预约即完成时同步清理门岗校验提示，避免禁用字段仍残留旧的必填报错。
     */
    handleFinishOnBookingChange() {
      if (!this.$refs.form) {
        return;
      }

      if (Number(this.form.finish_on_booking) === 1) {
        this.$refs.form.clearValidate(["info_door_ids", "out_door_ids"]);
      }
    },
    /**
     * 出车确认关闭时同步关闭北斗校验，避免隐藏字段残留影响后端校验方式。
     */
    handleDepartConfirmChange() {
      if (Number(this.form.need_depart_confirm) !== 1) {
        this.form.outward_beidou_check = 0;
        return;
      }
      this.form.outward_beidou_check =
        Number(this.form.outward_beidou_check) === 1 ? 1 : 0;
    },
    /**
     * 进出厂模式切换时，同步收敛地磅推送时机字段，避免发卡退卡业务误提交无效值。
     */
    handleAccessModeChange() {
      if (Number(this.form.access_mode) !== 1) {
        this.form.pound_push_timing = "";
        return;
      }
      if (!["NONE", "BOOKING", "REPORT"].includes(this.form.pound_push_timing)) {
        this.form.pound_push_timing = "NONE";
      }
    },
    /**
     * 停车场推送关闭时同步关闭停车场校验，避免前端残留旧值把无效配置提交给后端。
     */
    handleParkingLotPushTimingChange() {
      if (this.form.parking_lot_push_timing === "NONE") {
        this.form.parking_lot_space_intercept = 0;
        return;
      }
      if (![0, 1].includes(Number(this.form.parking_lot_space_intercept))) {
        this.form.parking_lot_space_intercept = 0;
      }
    },
    // 打开弹窗时兼容回填旧数据，并统一进厂后节点顺序。
    openModal(row) {
      this.visible = true;
      this.$nextTick(() => {
        if (row) {
          const newData = cloneDeep(row);
          newData.order_type = row.order_type || "OTHER";
          newData.pickup_booking_type = ["FINISHED", "TRI_WASTE", "OTHER"].includes(
            row.pickup_booking_type
          )
            ? row.pickup_booking_type
            : "OTHER";
          newData.finish_on_booking = Number(row.finish_on_booking) === 1 ? 1 : 0;
          newData.need_depart_confirm = Number(row.need_depart_confirm || 0);
          newData.outward_beidou_check =
            Number(row.outward_beidou_check) === 1 ? 1 : 0;
          newData.access_mode = Number(row.access_mode || 1);
          newData.pound_push_timing =
            row.pound_push_timing && ["NONE", "BOOKING", "REPORT"].includes(row.pound_push_timing)
              ? row.pound_push_timing
              : "NONE";
          newData.parking_lot_push_timing = ["NONE", "BOOKING", "OUTWARD"].includes(
            row.parking_lot_push_timing
          )
            ? row.parking_lot_push_timing
            : "NONE";
          newData.parking_lot_space_intercept =
            Number(row.parking_lot_space_intercept) === 1 ? 1 : 0;
          newData.post_entry_nodes = this.normalizePostEntryNodes(
            row.post_entry_nodes
          );
          // 列表展示字段是门岗对象数组，编辑表单需要 ID 数组，避免已有门岗在弹窗中丢失。
          newData.info_door_ids = this.normalizeBusinessDoorFormIds(
            row.info_door_ids,
            row.info_door_info
          );
          newData.out_door_ids = this.normalizeBusinessDoorFormIds(
            row.out_door_ids,
            row.out_door_info
          );
          this.form = Object.assign(this.form, newData);
          this.handleDepartConfirmChange();
          this.handleAccessModeChange();
          this.handleParkingLotPushTimingChange();
        }
      });
    },
    onOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const url = "/api/queue/admin/save_business";
          const payload = this.buildSavePayload(this.form);
          this.$common
            .http({
              url,
              data: payload,
              contentType: "application/json"
            })
            .then(() => {
              this.$message.success(`${this.form.id ? "修改" : "添加"}成功`);
              this.visible = false;
              this.$emit("ok");
            });
        }
      });
    },
    getDoors() {
      this.$common
        .http({
          url: "/api/queue/admin/query_door",
          data: { state: 1, keyword: "", page_size: 999 }
        })
        .then(res => {
          this.doors = res.data.data.data;
        });
    },
    onResetForm() {
      this.form = {
        id: 0,
        name: "",
        type: 11,
        order_type: "OTHER",
        pickup_booking_type: "OTHER",
        finish_on_booking: 0,
        need_depart_confirm: 0,
        outward_beidou_check: 0,
        access_mode: 1,
        pound_push_timing: "NONE",
        parking_lot_push_timing: "NONE",
        parking_lot_space_intercept: 0,
        post_entry_nodes: [...DEFAULT_POST_ENTRY_NODES],
        category: "",
        pid: "",
        user_list: "",
        auto_auth_units: "",
        note: "",
        enable_loadometer: "",
        car_tag: "",
        info_door_ids: [],
        out_door_ids: []
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 关键步骤：保存时仅提交后端真正使用的字段，避免整行对象回传导致请求过长。
    buildSavePayload(form) {
      return {
        id: form.id || 0,
        name: form.name,
        type: form.type,
        order_type: form.order_type,
        pickup_booking_type:
          Number(form.type) === 12 ? form.pickup_booking_type : "OTHER",
        finish_on_booking: Number(form.finish_on_booking) === 1 ? 1 : 0,
        need_depart_confirm: form.need_depart_confirm,
        outward_beidou_check:
          Number(form.need_depart_confirm) === 1 &&
          Number(form.outward_beidou_check) === 1
            ? 1
            : 0,
        access_mode: form.access_mode,
        pound_push_timing:
          Number(form.access_mode) === 1 ? form.pound_push_timing : "",
        parking_lot_push_timing: form.parking_lot_push_timing,
        parking_lot_space_intercept:
          form.parking_lot_push_timing === "NONE"
            ? 0
            : Number(form.parking_lot_space_intercept) === 1
            ? 1
            : 0,
        post_entry_nodes: this.normalizePostEntryNodes(form.post_entry_nodes),
        category: form.category,
        pid: form.pid,
        note: form.note,
        enable_loadometer: form.enable_loadometer,
        car_tag: form.car_tag,
        info_door_ids: form.info_door_ids,
        out_door_ids: form.out_door_ids,
        code: form.code || "",
        selective_type: form.selective_type,
        correlation_order_state: form.correlation_order_state,
        correlation_operator_type: form.correlation_operator_type,
        correlation_model: form.correlation_model,
        ncc_weight_unit: form.ncc_weight_unit,
        pound_check_weight: form.pound_check_weight,
        is_sap_check: form.is_sap_check || 0,
        is_delivery_code: form.is_delivery_code || 0,
        is_sampling: form.is_sampling || 0,
        is_auth: form.is_auth || 0
      };
    },
    // 统一进厂后节点顺序，避免展示顺序与后端判断不一致。
    normalizePostEntryNodes(nodes) {
      const allNodeOrder = this.postEntryNodeOptions.map(item => item.value);
      const nodeSet = new Set(Array.isArray(nodes) ? nodes : []);
      return allNodeOrder.filter(item => nodeSet.has(item));
    },
    // 统一回填门岗 ID，兼容后端返回的 JSON 字符串、数组和列表展示用门岗对象数组。
    normalizeBusinessDoorFormIds(doorIds, doorInfo = []) {
      if (Array.isArray(doorIds)) {
        return doorIds
          .map(doorItem => (doorItem && doorItem.id ? doorItem.id : doorItem))
          .filter(Boolean);
      }

      if (doorIds) {
        try {
          const parsedDoorIds = JSON.parse(doorIds);
          if (Array.isArray(parsedDoorIds)) {
            return parsedDoorIds.filter(Boolean);
          }
        } catch (error) {
          // 解析旧字段失败时继续尝试展示字段，避免异常历史值导致编辑弹窗门岗为空。
        }
      }

      if (Array.isArray(doorInfo)) {
        return doorInfo
          .map(doorItem => (doorItem && doorItem.id ? doorItem.id : ""))
          .filter(Boolean);
      }

      return [];
    }
  },
  watch: {
    "form.type"(type) {
      // 关键步骤：非提货业务不允许残留成品或三废配置。
      if (Number(type) !== 12) {
        this.form.pickup_booking_type = "OTHER";
      }
    },
    "form.access_mode"() {
      this.handleAccessModeChange();
    },
    "form.parking_lot_push_timing"() {
      this.handleParkingLotPushTimingChange();
    }
  }
};
</script>

<style lang="less" scoped>
.service-form-wrap {
  padding-right: 32px;
}
</style>
